module.exports = "#version 100\r\n#extension GL_EXT_draw_buffers: enable\r\nprecision highp float;\r\n\r\nuniform sampler2D u_oriSceenBuffer;\r\n\r\nvarying vec2 v_uv;\r\n\r\n\r\nvoid main() {\r\n\r\n    vec3 OriCol = vec3(texture2D(u_oriSceenBuffer, v_uv));\r\n\r\n    float brightness = OriCol.r * 0.2126 + OriCol.g * 0.7152 + OriCol.b * 0.0722;\r\n\r\n    OriCol = brightness * OriCol;\r\n\r\n    //gl_FragColor = vec4(OriCol, 1.0);\r\n\r\n    //Render to FBO\r\n    gl_FragData[0] = vec4(OriCol, 1.0);\r\n\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/shaders/brightnessFilterRTT.frag.glsl
// module id = 8
// module chunks = 0